import React from "react";
import "./Finance.css";

const Finance = () => {
  const financeProducts = [
    {
      id: 1,
      name: "Loan Management System",
      description: "Comprehensive platform for managing loan portfolios and lending operations.",
      features: [
        "Loan application processing",
        "Credit scoring integration",
        "Payment scheduling",
        "Collateral management",
        "Delinquency tracking",
        "Regulatory compliance"
      ],
      expectations: [
        "Streamlined loan origination",
        "Reduced default rates",
        "Automated payment processing",
        "Real-time portfolio analytics"
      ],
      customization: [
        "Custom loan products",
        "Credit bureau integrations",
        "Multi-branch support",
        "Mobile repayment options"
      ]
    },
    {
      id: 2,
      name: "Donation/Charity Management",
      description: "Complete solution for nonprofit organizations to manage donations and fundraising.",
      features: [
        "Donor management",
        "Campaign tracking",
        "Recurring donations",
        "Tax receipt generation",
        "Volunteer coordination",
        "Impact reporting"
      ],
      expectations: [
        "Increased donation revenue",
        "Donor retention improvement",
        "Reduced administrative work",
        "Transparent reporting"
      ],
      customization: [
        "Custom donation forms",
        "Peer-to-peer fundraising",
        "CRM integration",
        "Event management"
      ]
    },
    {
      id: 3,
      name: "Subscription Billing System",
      description: "Automated platform for managing recurring revenue and subscription services.",
      features: [
        "Recurring billing",
        "Payment processing",
        "Dunning management",
        "Usage tracking",
        "Customer self-service",
        "Revenue recognition"
      ],
      expectations: [
        "Reduced churn",
        "Automated invoicing",
        "Flexible pricing models",
        "Scalable billing operations"
      ],
      customization: [
        "Custom billing cycles",
        "Tiered pricing",
        "Trial management",
        "API integrations"
      ]
    },
    {
      id: 4,
      name: "Budget & Expense Tracker",
      description: "Personal and business financial management tool for tracking income and expenses.",
      features: [
        "Transaction categorization",
        "Budget planning",
        "Bill reminders",
        "Financial reporting",
        "Multi-account sync",
        "Investment tracking"
      ],
      expectations: [
        "Improved financial awareness",
        "Reduced unnecessary spending",
        "Savings goal achievement",
        "Tax preparation readiness"
      ],
      customization: [
        "Custom categories",
        "Business expense rules",
        "Bank integration",
        "Collaborative budgeting"
      ]
    }
  ];

  return (
    <div className="finance-container">
      <div className="finance-header">
        <h1>Finance & Utility Solutions</h1>
        <p className="subtitle">Robust financial tools to manage money, donations, and recurring billing</p>
      </div>

      <div className="finance-grid">
        {financeProducts.map((product) => (
          <div key={product.id} className="finance-card">
            <div className="finance-card-header">
              <h2>{product.name}</h2>
              <p className="finance-card-description">{product.description}</p>
            </div>

            <div className="finance-card-details">
              <div className="finance-card-section">
                <h3>Key Features</h3>
                <ul>
                  {product.features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
              </div>

              <div className="finance-card-section">
                <h3>What you can Expect</h3>
                <ul>
                  {product.expectations.map((expectation, index) => (
                    <li key={index}>{expectation}</li>
                  ))}
                </ul>
              </div>

              <div className="finance-card-section">
                <h3>Customization Options</h3>
                <ul>
                  {product.customization.map((option, index) => (
                    <li key={index}>{option}</li>
                  ))}
                </ul>
              </div>
            </div>

           {/*
<div className="finance-card-footer">
  <button className="finance-demo-button">Request Demo</button>
</div>
*/}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Finance;